import { __assign, __rest } from "tslib";
// MO9.1
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TierProductCardDumb from '../TierProductCardDumb/';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BuyCoreButton from '../../Button/BuyCoreButton';
import SubscribeButton from '../../Button/SubscribeButton';
import { getTierDescription, getTranslatedTierInfo } from '../_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import TierStateBadges from '../../Tier/TierStateBadges';
import MoreActionsButton from '../../Tier/MoreActionsButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import TierConsumerReduxModule from '../../Tier/redux/consumer/ModuleLoadable';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import HiddenOverlay from '../HiddenOverlay';
import s from './TierProductCard.scss';
var TierProductCard = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation, onPublish = _a.onPublish, onSubmitToTier = _a.onSubmitToTier, rest = __rest(_a, ["deviation", "onPublish", "onSubmitToTier"]);
    var t = useTranslation().t;
    var _e = useState(false), isPublishing = _e[0], setIsPublishing = _e[1];
    var _f = useState(false), matureFilterOverridden = _f[0], setMatureFilterOverridden = _f[1];
    var isOwner = useSubscriptionTier(deviation).isOwner;
    var info = isOwner ? undefined : getTranslatedTierInfo(deviation, t);
    var canPublish = (_b = deviation.tier) === null || _b === void 0 ? void 0 : _b.canUserPublish;
    var hasDiscord = (_d = (_c = deviation.tier) === null || _c === void 0 ? void 0 : _c.discord) === null || _d === void 0 ? void 0 : _d.connected;
    var _g = useDeviationMatureFilter(deviation), showBlocked = _g.showBlocked, overrideMatureFilter = _g.overrideMatureFilter;
    var onOverrideFilterClick = useCallback(function () {
        overrideMatureFilter();
        setMatureFilterOverridden(true);
    }, [overrideMatureFilter, setMatureFilterOverridden]);
    var ctaButton;
    if (!deviation.tier) {
        return null;
    }
    var onPublishClick = function () {
        if (onPublish) {
            setIsPublishing(true);
            onPublish(deviation);
            // this is a poor man's solution to unlock the button, in case we can't one-click publish (e.g. not all required fields are filled)
            // and open the edit tier popup. if the users closes it, we want to button to render restored in active state.
            setTimeout(function () {
                setIsPublishing(false);
            }, 3000);
        }
    };
    if (isOwner) {
        if (deviation.tier.state === 'draft') {
            if (canPublish) {
                // publishDraftTierSaga
                ctaButton = (React.createElement(React.Fragment, null,
                    React.createElement(SolidButton, { variant: "approval-green", size: "large", onClick: onPublishClick, loading: isPublishing }, t('deviationview.tierCard.cta.publish')),
                    React.createElement(TierConsumerReduxModule, null)));
            }
            else {
                // missing core - currently the only reason the owner cant publish
                ctaButton = (React.createElement(BuyCoreButton, { size: "large", biData: {
                        referral_info: ReferralType.SUBSCRIPTIONS_TIER_DRAFT,
                    } }, t('deviationview.tierCard.cta.getCore')));
            }
        }
        else if (deviation.tier.state === 'active') {
            ctaButton = (React.createElement(GhostButton, { variant: "main", size: "large", onClick: onSubmitToTier, biData: BiData({
                    evid: 704,
                    sectionname: 'tiers',
                }) }, t('deviationview.tierCard.cta.submitToTier')));
        }
    }
    else {
        ctaButton = (React.createElement(SubscribeButton, { size: "large", tier: deviation, matureFilterDisabled: true }));
    }
    return (React.createElement("div", { className: s['card-root'] },
        showBlocked && (React.createElement(HiddenOverlay, { className: s['card-overlay'], showBackground: false, deviation: deviation, overrideMatureFilter: onOverrideFilterClick })),
        React.createElement(TierProductCardDumb, __assign({ info: info, coverImage: deviation.coverImage, showMatureCover: showBlocked || matureFilterOverridden, coverAreaExtrasLeft: React.createElement(TierStateBadges, { deviation: deviation, showNeedCoreState: true, showPendingDeletionState: true }), dataHook: deviation.url, coverAreaExtrasRight: React.createElement(MoreActionsButton, { deviation: deviation }), stats: deviation.tier.stats, title: deviation.title, tierState: deviation.tier.state, description: getTierDescription(deviation), price: deviation.tier.dollarPrice, benefits: deviation.tier.benefits, ctaButton: ctaButton, hasDiscord: hasDiscord }, rest))));
};
TierProductCard.displayName = 'TierProductCard';
export default TierProductCard;
//# sourceMappingURL=TierProductCard.js.map